<template>
    <div class="term">
        <section class="home-cards">
        <h4>Termly Requirements</h4>
        <hr class="hr">
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/baby.svg" alt="termly requirements">
                </div>
                <div class="feature-title">
                <h5>BABY CLASS</h5>
                </div>
                  <ul class="feature-detail">
                      <li>1 ream of paper</li>
                      <li>1 roll of tissue</li>
                      <li> 1 bottle of liquid hand wash </li>
                      <li>1 bottle of hand sanitizer</li>
                      <li>10 co1ored hard manila paper</li>
                      <li>1 stick glue</li>
                      <li>2 box of Crayon</li>
                      <li>6 pencils</li>
                      <li>1 clear bag</li>
                  </ul>
            </div>
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/back_to_school.svg" alt="termly requirements">
                </div>
                <div class="feature-title">
                <h5>MIDDLE CLASS</h5>
                </div>
                  <ul class="feature-detail">
                      <li>1 ream of paper</li>
                      <li>1 roll of tissue</li>
                      <li> 1 bottle of liquid hand wash </li>
                      <li>1 bottle of hand sanitizer</li>
                      <li>10 A4 Hard Cover books (lined) 2 A4 Hard Cover books (squared)</li>
                      <li>2 erasers</li>
                      <li>5 pencils</li>
                      <li>6 pens</li>
                      <li>1 mathematical set</li>
                      <li>Atlas (Zambian)</li>
                      <li>Dictionary</li>
                  </ul>
            </div>
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/star.svg" alt="termly requirements">
                </div>
                <div class="feature-title">
                <h5>RECEPTION</h5>
                </div>
                  <ul class="feature-detail">
                      <li>1 ream of paper</li>
                      <li>1 roll of tissue</li>
                      <li> 1 bottle of liquid hand wash </li>
                      <li>1 bottle of hand sanitizer</li>
                      <li>10 small lines, 2 sn1all boxed and 2 plain books</li>
                      <li>2 erasers</li>
                      <li>2 box of Crayon</li>
                      <li>10 pencils</li>
                      <li>1 clear bag</li>
                  </ul>
            </div>
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/child.svg" alt="termly requirements">
                </div>
                <div class="feature-title">
                <h5>LOWER PRIMARY (GRADES 1 to 4)</h5>
                </div>
                  <ul class="feature-detail">
                      <li>1 ream of paper</li>
                      <li>1 roll of tissue</li>
                      <li> 1 bottle of liquid hand wash </li>
                      <li>1 bottle of hand sanitizer</li>
                      <li>8 A5 books (lined) 2 A5 books squared</li>
                      <li>2 khaki covers</li>
                      <li>1 pack of Crayon</li>
                      <li>6 pencils</li>
                      <li>1 clear bag</li>
                  </ul>
            </div>
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/terms.svg" alt="termly requirements">
                </div>
                <div class="feature-title">
                <h5>UPPER PRIMARY (GRADES 5 to 7)</h5>
                </div>
                  <ul class="feature-detail">
                      <li>1 ream of paper</li>
                      <li>1 roll of tissue</li>
                      <li> 1 bottle of liquid hand wash </li>
                      <li>1 bottle of hand sanitizer</li>
                      <li>10 A4 Hard Cover books (lined) 2 A4 Hard Cover books (squared)</li>
                      <li>2 erasers</li>
                      <li>5 pencils</li>
                      <li>6 pens</li>
                      <li>1 mathematical set</li>
                      <li>Atlas (Zambian)</li>
                      <li>Dictionary</li>
                  </ul>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Termly-Requirements',
  components: { }
}
</script>

<style>
.term .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.term .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.term .home-cards .home-cards-main {
  padding: 1em;
  max-width: 600px;
  margin: 0 auto;
}
.term .feature {
  background-color: #00000070;
  margin: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.term .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.term .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.term .feature li {
  color: var(--inspire-rose);
}
.term .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.term .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.term .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
  text-decoration: none;
  list-style-type: none;
}
</style>
